import axios from 'axios'

export const Project = {
    getList: () => axios.get(`/api/project-list/`),
    get: (slug) => axios.get(`/api/project/${slug}/`),
}
